import { useEffect, useRef } from 'react';
import PaymentsAPIServiceV2 from '@/services/PaymentsServiceV2';

const paymentsService = PaymentsAPIServiceV2.getInstance();
import { useNavigate } from 'react-router-dom';

export const useDanLonCallback = () => {
    const navigate = useNavigate();
    const processed = useRef(false);
    const exchange = async (code: string) => {
        let { data } = await paymentsService.dalonExchange(code);
        if (data) {
            const { selectCompanyUrl } = data;
            if (selectCompanyUrl) {
                window.location.href = selectCompanyUrl;
            }
        }
    };

    const code2token = async (code: string) => {
        let _response = await paymentsService.dalonCode2Token(code);
        navigate('/settings/general');
    };

    useEffect(() => {
        // Check if we're on the callback URL
        const currentPath = window.location.pathname;
        const isCallbackPath = currentPath.includes('danlon/callback');

        if (isCallbackPath) {
            // Extract the code from the URL search params
            const urlParams = new URLSearchParams(window.location.search);
            const authCode = urlParams.get('code');
            const companyid = urlParams.get('companyid');

            if (authCode && !processed.current && !companyid) {
                processed.current = true;
                exchange(authCode);
            } else if (authCode && !processed.current && companyid) {
                processed.current = true;
                code2token(authCode);
            }
        }
    }, []);
};
